import { render, staticRenderFns } from "./EDTagsForm.vue?vue&type=template&id=643548bf&"
import script from "./EDTagsForm.vue?vue&type=script&lang=js&"
export * from "./EDTagsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643548bf')) {
      api.createRecord('643548bf', component.options)
    } else {
      api.reload('643548bf', component.options)
    }
    module.hot.accept("./EDTagsForm.vue?vue&type=template&id=643548bf&", function () {
      api.rerender('643548bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/EDTagsForm.vue"
export default component.exports